// Transform phase data for Stripe
export function transformData(phases, summary) {
  if (!Array.isArray(phases)) phases = [phases];

  return phases.map((phase) => {
    // Recurring subscription items
    const recurringItems = (phase.items || [])
      .filter(item => item.plan !== undefined) // Only items with a plan are recurring
      .map(item => ({
        price_data: {
          currency: "gbp",
          product: item.product_id || item.price,
          recurring: {
            interval_count: summary?.interval_count || "",
            interval: summary?.interval || "",
          },
          tax_behavior: "unspecified",
          unit_amount_decimal: item.unit_price ? item.unit_price * 100 : 0,
        },
        quantity: item.quantity,
        tax_rates: Array.isArray(item.tax_rates) && item.tax_rates.length ? item.tax_rates : [],
      }));

    // One-time charges
    const chargeItems = (phase.items || [])
      .filter(item => item.plan === undefined || item.productType === "charge")
      .map(item => ({
        price_data: {
          currency: "gbp",
          product: item.product_id || item.price,
          tax_behavior: "unspecified",
          unit_amount_decimal: item.unit_price ? item.unit_price * 100 : 0,
        },
        quantity: item.quantity,
        tax_rates: Array.isArray(item.tax_rates) && item.tax_rates.length ? item.tax_rates : [],
      }));


    return {
      ...phase,
      items: recurringItems,           // only recurring
      add_invoice_items: chargeItems,  // only charges
    };
  });
}

export function removeMatchingItems(data) {
  return data.map((entry) => {
    const { items = [], add_invoice_items = [] } = entry;

    // Helper: remove duplicates by product ID
    const uniqueByProduct = (arr) => {
      const seen = new Set();
      return arr.filter(item => {
        const productId = item?.price_data?.product;
        if (!productId) return true; // keep items with no product_data
        if (seen.has(productId)) return false;
        seen.add(productId);
        return true;
      });
    };

    // Remove duplicates from both arrays
    const filteredItems = uniqueByProduct(items);
    const filteredAddInvoiceItems = uniqueByProduct(add_invoice_items);

    return {
      ...entry,
      items: filteredItems,
      add_invoice_items: filteredAddInvoiceItems,
    };
  });
}



export const UpdateData = (
  state,
  order_id,
  summary,
  podQty,
  editOrderDetail
) => {

  function updateItems(data) {
    return data.map((entry) => {
      // Separate the items with productType 'charge'
      const newAddInvoiceItems = entry.items.filter(
        (item) => item.plan == undefined || item.productType === "charge"
      );

      // Filter out the 'charge' items from the original items array
      const updatedItems = entry.items.filter(
        (item) => item.productType !== "charge"
      );

      // Return the updated entry with modified items and add_invoice_items
      return {
        ...entry,
        items: [...updatedItems, ...newAddInvoiceItems], // Update items
        // add_invoice_items: [...entry.add_invoice_items, ...newAddInvoiceItems], // Add charge items to add_invoice_items
      };
    });
  }

  const updatedData = updateItems(state.phases);

  const transform = transformData(updatedData, summary);
  
  
  const testing = removeMatchingItems(transform);

  // state.phases = transform
  const va = {
    ...state,
    phases: testing,
  };
  const data = {
    order_id: order_id,
    planPodsQty: podQty || 1,
    customer_id: state?.customer,
    subscription_scheduled_id: state.id,
    subscription_id:
      //  editOrderDetail?.subscription_id
      //   ? editOrderDetail?.subscription_id
      //   :
      state.subscription?.id ? state.subscription?.id : "",
    schedule_data: va,
    insurance_cover: state.insurance_cover,
    insurance_cost: state.insurance_price,
  };
  delete data.schedule_data.insurance_cover;

  const removeNullValuesAndKeys = (obj, keysToRemove) => {
    if (Array.isArray(obj)) {
      return obj
        .map((item) => removeNullValuesAndKeys(item, keysToRemove)) // Recursively clean arrays
        .filter((item) => item !== null); // Filter out null items
    } else if (typeof obj === "object" && obj !== null) {
      return Object.keys(obj).reduce((acc, key) => {
        if (obj?.trial_end) {
          delete obj.billing_cycle_anchor;
        }

        if (obj?.object == "tax_rate") {
          const gg = obj?.id;
          return gg;
        }
        if (!keysToRemove.includes(key)) {
          // Exclude specific keys
          const value = removeNullValuesAndKeys(obj[key], keysToRemove);
          if (value !== null) {
            acc[key] = value;
          }
        }
        return acc;
      }, {});
    }
    return obj;
  };

  // Add "coupon" to the list of keys to remove
  const keysToRemove = [
    "livemode",
    "subscription",
    "id",
    "object",
    "default_settings",
    "customer",
    "current_phase",
    "status",
    "created",
    "coupon",
    "unit_price",
    "product_name",
    "is_edit",
    "productType",
    "plan",
    "canceled_at",
    "completed_at",
    "is_call_upcoming",
    "is_add_phase",
    "chargebee_subscription_id",
    "trial",
    "prebilling",
    "insurance_price",
    "pending_setup_intent",
  ];

  // Clean the data
  const cleanedData = removeNullValuesAndKeys(data, keysToRemove);
  return cleanedData;
};

// Example usage

export function resetDiscounts(data) {
  if (data && data.schedule_data && data.schedule_data.phases) {
    data.schedule_data.phases.forEach((phase) => {
      phase.discounts = []; // Set discounts to an empty array
    });
  }
  return data;
}
